var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBarcode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "511.626px",
    height: "511.627px",
    viewBox: "0 0 511.626 511.627",
    style: {
      enableBackground: "new 0 0 511.626 511.627"
    },
    xmlSpace: "preserve",
    fill: "var(--light-grey)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 134.761,
    y: 54.816,
    width: 17.699,
    height: 401.707
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.786,
    y: 54.816,
    width: 8.848,
    height: 401.707
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.568,
    y: 54.816,
    width: 8.852,
    height: 401.707
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.581,
    y: 54.816,
    width: 8.852,
    height: 401.707
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.84,
    y: 54.816,
    width: 9.136,
    height: 401.707
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.959,
    y: 54.816,
    width: 8.851,
    height: 401.707
  }), /*#__PURE__*/React.createElement("rect", {
    y: 54.816,
    width: 17.987,
    height: 401.994
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.557,
    y: 54.816,
    width: 8.852,
    height: 401.707
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.856,
    y: 54.816,
    width: 17.986,
    height: 401.707
  }), /*#__PURE__*/React.createElement("rect", {
    x: 439.966,
    y: 54.816,
    width: 26.837,
    height: 401.707
  }), /*#__PURE__*/React.createElement("rect", {
    x: 475.653,
    y: 54.816,
    width: 9.134,
    height: 401.707
  }), /*#__PURE__*/React.createElement("rect", {
    x: 493.64,
    y: 54.816,
    width: 17.986,
    height: 401.994
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.045,
    y: 54.816,
    width: 17.987,
    height: 401.707
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.019,
    y: 54.816,
    width: 17.987,
    height: 401.707
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.072,
    y: 54.816,
    width: 17.986,
    height: 401.707
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.243,
    y: 54.816,
    width: 17.989,
    height: 401.707
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarcode);
export default __webpack_public_path__ + "static/media/barcode.624ebd4252bc7953d379132ab022c732.svg";
export { ForwardRef as ReactComponent };